import React from 'react';

interface Props {
  direction: 'left' | 'right';
}

const CashFlow = ({ direction }: Props) => {
  return (
    <div className="p-3 d-flex flex-row justify-content-between" style={{ fontSize: '40px', width: '468px' }}>
      <div className="ml-3">
        <i className="far fa-user" />
      </div>
      <div className="flex-grow-1 text-success" style={{ overflow: 'hidden' }}>
        <i className={`fal fa-money-bill-alt fly-${direction}`} />
      </div>
      <div className="mr-3">
        <i className="far fa-cash-register" />
      </div>
    </div>
  );
};

export default CashFlow;
